import React, { FC, useState } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Button, Typography } from '@altermaind/web/ui';
import { ReadMoreTypographyProps } from './types';

export const ReadMoreTypography: FC<ReadMoreTypographyProps> = ({
  children,
  maxLines = 8,
  readMoreLabel,
  readLessLabel,
  style,
  ...typographyProps
}) => {
  const t = useTranslations('sharedComponents.readMoreTypography');
  const readMoreLabelToUse = readMoreLabel || t('readMoreLabel');
  const readLessLabelToUse = readLessLabel || t('readLessLabel');
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <Typography
        ellipsis={!expanded}
        numberOfLines={expanded ? undefined : maxLines}
        style={style}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...typographyProps}
      >
        {children}
      </Typography>
      <Typography
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...typographyProps}
      >
        <Button
          variant='link/primary'
          onClick={() => setExpanded(!expanded)}
          style={{ textDecoration: 'none', fontSize: 'inherit', height: 'auto' }}
        >
          {expanded ? readLessLabelToUse : readMoreLabelToUse}
        </Button>
      </Typography>
    </>
  );
};
